import * as React from 'react'

import { TagColor } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  selected?: boolean
  disabled?: boolean
  color?: TagColor
  onClick?: React.MouseEventHandler<HTMLTableRowElement>
  onMouseEnter?: React.MouseEventHandler<HTMLTableRowElement>
  onMouseLeave?: React.MouseEventHandler<HTMLTableRowElement>
}

export default function TableRow({
  onClick,
  onMouseEnter,
  onMouseLeave,
  selected = false,
  disabled = false,
  color,
  children,
}: React.PropsWithChildren<Props>) {
  let attributes: React.HTMLAttributes<HTMLTableRowElement> = {
    className: cx(
      'tr',
      {
        clickable: !!onClick,
        selected,
        disabled,
      },
      color
    ),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
  }

  if (onClick) {
    attributes = { ...attributes, onClick: onClick }
  }

  return <tr {...attributes}>{children}</tr>
}
